import { render, staticRenderFns } from "./re-captcha.vue?vue&type=template&id=33305858&scoped=true&"
import script from "./re-captcha.vue?vue&type=script&lang=js&"
export * from "./re-captcha.vue?vue&type=script&lang=js&"
import style0 from "./re-captcha.vue?vue&type=style&index=0&id=33305858&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33305858",
  null
  
)

export default component.exports